import Comps from '@owenscorning/react-library';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import CurrentPropertyOwner from './CurrentPropertyOwner';
import NoAvailableWarranty from './NoAvailableWarranty';
import RepAssistance from './RepAssistance';
import RoofInstallDate from './RoofInstallDate';
import CTAButton from '../../../CTAButton';
import BackButton from '../../shared/BackButton';
import AddressVerificationModal from '../helpers/address-verification-modal';
import { setFormData, backToForThisProperty, decrementStep, verifyAddress } from '../redux/action';

const { AddressGroup } = Comps.Connect.FormElements;
const { Spinner } = Comps.Connect;

function Step2() {
  const formData = useSelector(state => state.formData);
  const isFetching = useSelector(state => state.isFetching);
  const dispatch = useDispatch();

  return (
    <>
      {formData.showRoofInstallDate && <RoofInstallDate />}
      {formData.showCurrentPropertyOwner && <CurrentPropertyOwner />}
      {formData.showNoAvailableWarray && <NoAvailableWarranty />}
      {formData.showRepAssistance && <RepAssistance />}

      {!(
        formData.showRoofInstallDate ||
        formData.showNoAvailableWarray ||
        formData.showRepAssistance ||
        formData.showCurrentPropertyOwner
      ) && (
        <div>
          <BackButton
            analytics={{
              'data-track': 'form-back',
              'data-track-form-name': 'Submit Claim',
              'data-track-form-step': 'step 2 - where was the roof installed',
            }}
            onClick={() => dispatch(decrementStep())}
            backText="For this property, are you the..."
          />
          <p>Thanks for that! Now, we need a little more information to help us locate the warranty. First, tell us:</p>

          <h4>Where was the roof installed?</h4>
          <AddressGroup
            value={formData.propertyAddress}
            onChange={address => {
              dispatch(
                setFormData({
                  propertyAddress: {
                    ...formData.propertyAddress,
                    ...address,
                  },
                })
              );
            }}
            suggestionEndpoint={`${MDMS_URL}/api/v1/smarty/suggestions`}
            showComplaints={false}
            country={formData.countrySelected}
          />

          <CTAButton
            onClick={() => dispatch(verifyAddress('propertyAddress'))}
            data-track="form-advance"
            data-track-form-name="Submit Claim"
            data-track-form-step="step 2 - where was the roof installed"
            element="button"
            text={
              isFetching ? (
                <>
                  <Spinner /> Loading
                </>
              ) : (
                'Next'
              )
            }
            type="submit"
            disabled={
              !(
                formData.propertyAddress.street &&
                formData.propertyAddress.city &&
                formData.propertyAddress.state &&
                formData.propertyAddress.zip
              )
            }
          />
          <AddressVerificationModal fieldKey="propertyAddress" />
        </div>
      )}
    </>
  );
}

export default Step2;
